import { Box, Flex } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { theme } from '@resistapp/client/components/shared/theme';

type SmartChipActionFooterProps = {
  leading?: ReactNode;
  trailing?: ReactNode;
};

export function SmartChipActionFooter({ leading, trailing }: SmartChipActionFooterProps) {
  return (
    <Flex justify="space-between" align="center" wrap="nowrap" gap={theme.spacing[3]} width="100%" minWidth={0}>
      <Box flex="1 1 auto" minWidth={0}>
        {leading}
      </Box>
      <Box flexShrink={0} minWidth={0} ml={theme.spacing[4]}>
        {trailing}
      </Box>
    </Flex>
  );
}
